module.exports = __webpack_public_path__ + "static/media/s_v5_t9_2.6d008fbf.mp3";